<!--
 * @Author: Scarlett Xiao
 * @Date: 2022-01-04 15:05:32
 * @LastEditors: lishiqiao
 * @LastEditTime: 2023-09-13 11:15:35
-->
<template>
  <div class="page-list">
    <!-- 实时存塘量 -->
    <div class="page-search-content" ref="searchBox">
      <div class="page-big-box">
        <div class="page-search-item">
          <label>机构&nbsp;:</label>
          <el-select v-model="param.params.orgId" placeholder="请选择机构">
            <el-option label="全部机构" value=""></el-option>
            <el-option :key="item.id" v-for="item in GongSiList" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>造次&nbsp;:</label>
          <el-select v-model="periodId" multiple collapse-tags placeholder="请选择造次" @change="selectPeriod"
            @remove-tag="removeTag">
            <el-option el-option label="全选" value="全选" @click.native="selectAll"></el-option>
            <el-option :key="item.id" v-for="item in PiCiList" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>品类&nbsp;:</label>
          <el-select v-model="param.params.breedTypeId" placeholder="请选择品类">
            <el-option label="全部品类" value=""></el-option>
            <el-option :key="item.id" v-for="item in PinLeiList" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>品种&nbsp;:</label>
          <el-select v-model="param.params.breedId" placeholder="请选择品种">
            <el-option label="全部品种" value=""></el-option>
            <el-option :key="item.id" v-for="item in PinZhongList" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
      </div>
      <div class="page-search-btn">
        <div class="search-btn" @click="pageSearch">查询</div>
        <div class="reset-btn" @click="reSet">重置</div>
        <div class="search-close-btn">
          <div @click="PageSearchClose" v-if="PageDisplay">
            <span>收起</span><i class="iconfont icon-a-List-Expand"></i>
          </div>
          <div @click="PageSearchOn" v-else>
            <span>展开</span><i class="iconfont icon-List-Collapse"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="page-list-content">
      <div class="page-list-title">
        <div><i class="title-icon"></i>养成单位利润计划与实际比较</div>
        <div>单位 : {{ tableTitle }}</div>
        <div></div>
        <div>
          <el-dropdown style="margin-right: 30px;" @command="setFixedColumn">
            <span class="el-dropdown-link">
              冻结列<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="y">冻结至"{{
                fixedColumn.label
              }}"列</el-dropdown-item>
              <el-dropdown-item command="n">取消冻结</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span @click="doExport">
            <i class="title-export-btn iconfont icon-a-List-Export"></i>导出报表
          </span>
        </div>
      </div>
      <el-table :row-class-name="tableRowClassName" :data="tableData" :max-height="tableHeight" border style="width: 100%"
        @header-click="handleClick">
        <el-table-column :fixed="fixedColumnList[0].fixed" :class-name="fixedColumnList[0].selected ? 'cellSelected' : ''"
          prop="orgName" label="机构"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[1].fixed" :class-name="fixedColumnList[1].selected ? 'cellSelected' : ''"
          prop="periodName" label="养殖造次"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[2].fixed" :class-name="fixedColumnList[2].selected ? 'cellSelected' : ''"
          prop="breedTypeName" label="养殖品类"></el-table-column>
        <el-table-column :fixed="fixedColumnList[3].fixed" :class-name="fixedColumnList[3].selected ? 'cellSelected' : ''"
          prop="breedName" label="养殖品种"></el-table-column>
        <el-table-column label="单位售价(元/斤)">
          <el-table-column prop="unitPriceTarget" label="计划"></el-table-column>
          <el-table-column prop="realityUnitPrice" label="实际"></el-table-column>
        </el-table-column>
        <el-table-column label="单位养殖成本(元/斤)">
          <el-table-column prop="unitCostTarget" label="计划"></el-table-column>
          <el-table-column prop="realityUnitCost" label="实际"></el-table-column></el-table-column>
        <el-table-column label="单位养殖利润（元/斤）">
          <el-table-column prop="unitProfitTarget" label="计划"></el-table-column>
          <el-table-column prop="realityUnitProfit" label="实际"></el-table-column></el-table-column>
        <el-table-column prop="harvestBoxNum" label="收获塘\箱总数"></el-table-column>
        <el-table-column prop="harvestWeight" label="收获总产量(斤)"></el-table-column>
        <!-- 查询年 显示 平均成活率% -->
        <el-table-column v-if="param.params.type === 'Y'" prop="survivalPercentage" label="平均成活率%"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {
  initPageList,
  getAllJiGou,
  getAllPinLei,
  getAllPinZhong,
  getAllPiCi,
} from "./yc-profit-services";
import Page from "@/utils/methods/page";
export default {
  name: "yc",
  data() {
    return {
      pickerOptions: {
        // 超出当前年份或月份不可选
        disabledDate: (time) => {
          return time.getTime() > Date.now();
        },
      },
      tableTitle: "",
      tableDate: "",
      tableHeight: 0, // 表格高度
      fixedColumn: {},
      fixedColumnList: [
        {
          prop: "orgName",
          fixed: false,
          selected: false
        },
        {
          prop: "periodName",
          fixed: false,
          selected: false
        },
        {
          prop: "breedTypeName",
          fixed: false,
          selected: false
        },
        {
          prop: "breedName",
          fixed: false,
          selected: false
        },
      ],
      param: {
        currPage: 1, //第几页
        pageSize: 10, //每页条数
        // orderBy: "desc",//排序
        // orderByName: "org_name",//排序字段
        params: {
          rootOrgId: localStorage.getItem("rootId"), //顶级机构id（公司）
          orgId: "", //机构id（公司）
          breedTypeId: "", //养殖造次id
          periodId: [], //育苗批次id
          seedlingDataId: [], //养殖品类
          breedId: "", //养殖品种id
          type: "Y", //时间查询类型 Y年 M月
          startDate: null, //开始时间 月
          year: null, //年
          breedTypeClass: "fish", //分页查询类型 egg育苗 fish养成
        },
      },
      date: null, //月份区间双向绑定数据
      dateSelectNum: 1,
      PageDisplay: true,
      value: "",
      tableData: [],
      GongSiList: [], //养殖场下拉数据
      PiCiList: [], //造次下拉数据
      PinLeiList: [], //品类下拉数据
      PinZhongList: [], //品种下拉数据
      periodId: [],
    };
  },
  computed: {},
  created() {
    this.tableHeight = window.innerHeight - 400;
  },
  mounted() {
    this.initPage(this.param);
    this.getAllSearchSelect();
    Page.pagesTableFixed();
  },
  methods: {
    doExport() {
      this.$confirm(`导出表格为excel文件，请确认！`, "操作提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      })
        .then(async () => {
          const param = {
            rootOrgId: this.param.params.rootOrgId,
            orgId: this.param.params.orgId,
            breedTypeId: this.param.params.breedTypeId,
            periodId: this.param.params.periodId,
            seedlingDataId: this.param.params.seedlingDataId,
            breedId: this.param.params.breedId,
            year: this.param.params.year,
            startDate: this.param.params.startDate,
            type: this.param.params.type,
            breedTypeClass: "fish",
            fileName: "养成-单位利润计划与实际比",
          };
          const flag = await Page.exportDatas(
            "/outFishProfitOrg/exportOutFishProfitOrgList",
            param
          );
        })
        .catch(() => { });
    },
    // 获取所有下拉选择项
    getAllSearchSelect() {
      let rootId = localStorage.getItem("rootId");
      Promise.all([
        getAllJiGou(rootId),
        getAllPiCi(rootId),
        getAllPinLei(rootId),
        getAllPinZhong(rootId),
      ])
        .then((result) => {
          const [JiGouData, PiCiData, PinLeiData, PinZhongData] = result;
          this.GongSiList = JiGouData.data;
          this.PiCiList = PiCiData.data;
          this.PinLeiList = PinLeiData.data;
          this.PinZhongList = PinZhongData.data;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.baseName === "合计") {
        return "heji-row";
      }
    },
    reSet() {
      this.param = {
        currPage: 1, //第几页
        pageSize: 10, //每页条数
        // orderBy: "desc",//排序
        // orderByName: "org_name",//排序字段
        params: {
          rootOrgId: localStorage.getItem("rootId"), //顶级机构id（公司）
          orgId: "", //机构id（公司）
          breedTypeId: "", //养殖造次id
          periodId: [], //育苗批次id
          seedlingDataId: [], //养殖品类
          breedId: "", //养殖品种id
          type: "Y", //时间查询类型 Y年 M月
          startDate: null, //开始时间 月
          year: null, //年
          breedTypeClass: "fish", //分页查询类型 egg育苗 fish养成
        },
      };
      this.periodId = [];
      this.initPage(this.param);
    },
    selectAll() {
      if (this.periodId.length < this.PiCiList.length) {
        this.periodId = [];
        this.PiCiList.map((item) => {
          this.periodId.push(item.id);
        });
        this.periodId.unshift("全选");
      } else {
        // 取消全选
        this.periodId = [];
      }
      if (this.periodId.length > 0) {
        if (this.periodId[0] == "全选") {
          this.param.params.periodId = ["total"];
        } else {
          this.param.params.periodId = this.periodId;
        }
      }
    },
    removeTag(val) {
      if (val === "全选") {
        this.periodId = [];
        this.param.params.periodId = [];
      }
    },
    selectPeriod(val) {
      if (!val.includes("全选") && val.length === this.PiCiList.length) {
        this.periodId.unshift("全选");
      } else if (
        val.includes("全选") &&
        val.length - 1 < this.PiCiList.length
      ) {
        this.periodId = this.periodId.filter((item) => {
          return item !== "全选";
        });
      }
      if (this.periodId.length > 0) {
        if (this.periodId[0] == "全选") {
          this.param.params.periodId = ["total"];
        } else {
          this.param.params.periodId = this.periodId;
        }
      }
    },
    // 查询按钮
    pageSearch() {
      this.initPage(this.param);
    },
    PageSearchClose() {
      Page.PageSearchClose(this);
    },
    PageSearchOn() {
      Page.PageSearchOn(this);
    },
    initPage(data) {
      const loading = this.$loading({
        lock: true,
        text: "数据加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      initPageList(data).then((res) => {
        this.tableTitle = Page.orgIdFilter(data.params.orgId, this.GongSiList);
        if (data.params.type === "Y") {
          this.tableDate = data.params.year;
        } else {
          this.tableDate = Page.costMonthFilter(data.params.startDate);
        }
        this.tableData = res.data.list;
        setTimeout(() => {
          loading.close();
        }, 0);
      });
    },

    // 选中列
    handleClick(column, event) {
      this.fixedColumnList.forEach((item, i) => {
        if (JSON.stringify(this.fixedColumnList).includes(column.property)) {
          if (item.prop === column.property) {
            item.selected = !item.selected;
            if (item.selected) {
              this.fixedColumn = column;
              this.fixedColumn.idx = i;
            } else {
              this.fixedColumn = {};
            }
          } else {
            item.selected = false;
          }
        }
      });
    },

    // 设置冻结列
    setFixedColumn(command) {
      if (command === 'y') {
        if (JSON.stringify(this.fixedColumn) === "{}") {
          this.$message('请选择列');
          return;
        }
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.fixedColumnList.forEach((item, i) => {
          if (i <= this.fixedColumn.idx) {
            item.fixed = true;
          }
        })
        this.$message('已冻结至"' + this.fixedColumn.label + '"列');
        this.fixedColumn = {};
      } else if (command === 'n') {
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.$message('已取消冻结');
      }
    }
  },
  // 数据监听
  watch: {
    date: function (newVal, oldVal) {
      if (newVal) {
        const [date1, date2] = newVal;
        const startMonth = Page.getCurrentMonth(date1);
        this.param.params.startDate = startMonth;
      }
    },
    "param.params.type": function (newVal, oldVal) {
      if (newVal === "Y") {
        this.param.params.startDate = null;
        this.date = null;
        this.param.params.year = Page.getCurrentYear();
        this.initPage(this.param);
        return;
      }
      this.param.params.year = null;
      const Timer = new Date();
      this.date = [Timer, Timer]; //给到当前年月-显示在日期区间选择框内
      this.param.params.startDate = Page.getCurrentMonth();
      this.initPage(this.param);
    },
  },
};
</script>

<style lang="less" scoped></style>